module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n  <div id="nodeContent" class="innerContent">\n\n\n  </div>\n\n';
}
return __p;
};
